import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'app/shared/components/button/button.module';
import { DateBoxModule } from 'app/shared/components/date-box/date-box.module';
import { InputBoxModule } from 'app/shared/components/input-box/input-box.module';
import { ListModule } from 'app/shared/components/list/list.module';
import { LoadingPanelModule } from 'app/shared/components/loading-panel/loading-panel.module';
import { PaginationModule } from 'app/shared/components/pagination/pagination.module';
import { ScrollViewModule } from 'app/shared/components/scroll-view/scroll-view.module';
import { SelectBoxModule } from 'app/shared/components/select-box/select-box.module';
import { ToolbarModule } from 'app/shared/components/toolbar/toolbar.module';
import { TooltipModule } from 'app/shared/components/tooltip/tooltip.module';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { OccurrenceRegisterModule } from '../occurrence-register/occurrence-register.module';
import { SearchOccurrenceComponent } from './search-occurrence.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SelectBoxModule,
    InputBoxModule,
    DateBoxModule,
    ButtonModule,
    TooltipModule,
    ToolbarModule,
    ListModule,
    PaginationModule,
    LoadingPanelModule,
    ScrollViewModule,
    OccurrenceRegisterModule,
    BlockModalDragModule,
  ],
  declarations: [SearchOccurrenceComponent],
  exports: [SearchOccurrenceComponent],
})
export class SearchOccurrenceModule {}
